import { useConflicts } from "@mapcraft-tasks/client-store/react";
import { Link } from "@tanstack/react-router";
import { useEffect, useRef, useState } from "react";

/**
 * Отклонённая операция откатывается САМА, без анимации и без ошибки — так устроена
 * rebase-модель стора. Задача интерфейса не откатить, а **сделать исчезновение
 * заметным**: иначе человек уверен, что перенёс задачу, а её там нет.
 *
 * Ключевой принцип: анимацию можно пропустить, поэтому она НИКОГДА не единственный
 * носитель. Тост несёт причину и живёт восемь секунд; постоянный бейдж в сайдбаре
 * и запись в `/conflicts` — до разбора (ui-spec Область 11).
 */
const TOAST_MS = 8000;

export function Toasts() {
	const conflicts = useConflicts();
	const seen = useRef(new Set<string>());
	const [visible, setVisible] = useState<{ opId: string; message: string }[]>([]);

	useEffect(() => {
		const fresh = conflicts.filter((c) => !seen.current.has(c.opId));
		if (fresh.length === 0) {
			return;
		}
		for (const conflict of fresh) {
			seen.current.add(conflict.opId);
		}
		setVisible((prev) => [...prev, ...fresh.map((c) => ({ opId: c.opId, message: c.message }))]);
		const ids = new Set(fresh.map((c) => c.opId));
		const timer = setTimeout(() => setVisible((prev) => prev.filter((t) => !ids.has(t.opId))), TOAST_MS);
		return () => clearTimeout(timer);
	}, [conflicts]);

	if (visible.length === 0) {
		return null;
	}

	return (
		/* На телефоне тост встаёт над панелью действий и во всю ширину: угол в 80 колонок
		   там просто не помещается. */
		<div className="pointer-events-none fixed right-3 bottom-[5.5rem] left-3 z-50 flex flex-col gap-2 md:right-6 md:bottom-12 md:left-auto md:w-80">
			{visible.map((toast) => (
				<div key={toast.opId} className="popover pointer-events-auto border-danger/50 px-4 py-3">
					<div className="text-sm font-medium text-danger">⚠ Операция отклонена</div>
					<div className="mt-1 text-xs font-light text-ink">{toast.message}</div>
					<Link
						to="/conflicts"
						className="mt-2 inline-block text-xs font-light text-link transition-colors hover:text-link-hover"
					>
						разобрать →
					</Link>
				</div>
			))}
		</div>
	);
}
